<div class="cont-login">
      <div class="centrador-vertical login flex-center-v">
            <div class="cont-real-login col-12">
                  <Input type="email" label="Email" bind:value={usr} fnEnter={waitingForLogin} />
                  <Input
                        type="password"
                        label="Clave"
                        clases="mb-0"
                        style="margin-bottom: 0px"
                        bind:value={pass}
                        fnEnter={waitingForLogin}
                  />
                  <div class="col-12" style="padding-left: 25px">
                        <Check bind:value={recordarPass} texto="Recordar Credenciales.." />
                        <!-- {recordarPass} -->
                  </div>
                  <div class="col-12" style="padding-left: 25px">
                        <Switch bind:value={recordarPass} texto="Recordar Credenciales.." />
                        <!-- {recordarPass} -->
                  </div>
                  <BotonNico
                        fnClick={waitingForLogin}
                        texto="Ingresar"
                        textoCargando="Ingresando.."
                        bind:cargando={ingresando}
                  />
            </div>
      </div>
</div>

<script>
      import BotonNico from "./BotonNico.svelte";
      import Input from "./Input.svelte";
      import {
            OPERADOR_LOGEADO_STORE,
            logearse,
            dameCredencialesUsuarioDeCookie,
      } from "../../stores/operador-logeado-store";
      import { PAGES_STORE, irA } from "../../utils/ROUTING.js";
      import Check from "./Check.svelte";
      import { onMount } from "svelte";
      import Switch from "./Switch.svelte";

      // Definimos variables reactivas
      export let usr = "";
      export let pass = "";
      let recordarPass = true;
      let ingresando = false;

      onMount(() => {
            let credenciales = dameCredencialesUsuarioDeCookie();
            console.log("CREDENCIALES:" + JSON.stringify(credenciales));

            if ("email" in credenciales && credenciales.email) {
                  usr = credenciales.email;
            }
            if ("pass" in credenciales && credenciales.pass) {
                  pass = credenciales.pass;
            }
      });

      // HANDLE LOGIN CLICK:
      async function waitingForLogin() {
            ingresando = true;
            await logearse(usr, pass, recordarPass);

            ingresando = false;
      }
</script>

<style>
      .centrador-vertical {
            height: 99vh;
      }
</style>
